import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useHookstate } from '@hookstate/core';
import $ from 'jquery';
import { usePathname } from 'next/navigation';

import Notification from '~/containers/Views/Notification/Notification.ui';
import ModalNotification from '~/components/ui/ModalNotification';
import { validateFormAvailability } from '~/helpers/validate_form';
import { SwalModal } from '~/store/Modals/sweet';
import { notifyAvailability } from '~/store/Query/api';
import { inventoryModal, useInventoryText } from '~/store/States/inventory';

import '../../sass/modules/_availability.scss';

const Modal = config => SwalModal({
  closeButtonHtml: '<i class="fas fa-times modal-close"></i>',
  ...config,
});

export const ModalAvailability = props => (
  <div className="modal-availability">
    <ModalNotification>
      <div className="text-center my-5 my-md-0 ModalRenewal">
        <nav>
          <button type="button" className="red-color btn-close" onClick={props.close}><span><i className="fas fa-times" /></span></button>
        </nav>
        <h1>{props.title}</h1>
        <p> {props.message}</p>
        <button type="button" className="red-claro-btn FirstBtn" onClick={props.close}>{props.btnMessage}</button>
      </div>
    </ModalNotification>
  </div>
);

export const ModalFormAvailability = (props) => {
  const pathname = usePathname();
  const [error, setError] = useState(null);
  useEffect(() => {
    //  carga una vez
    validateFormAvailability();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    const $form = $("form[name='formAvailability']");
    if ($form.valid()) {
      const query = {
        sku: props.item.part_number,
        product: props.item.locales[process.env.NEXT_PUBLIC_LOCALE].name.replace(/<br>|<br\/>|\\n/g, ''),
        href: pathname,
      };
      $('input[name]', $form).each((idx, element) => {
        if (element.value) {
          query[element.name] = element.value;
        }
      });

      const res = await notifyAvailability(query);
      if (res.ok) {
        props.notifyAvailability();
      } else {
        Modal({
          icon: res.body?.code === 400 ? 'warning' : 'error',
          text: res.body?.result?.message || 'Ha ocurrido un error.',
        });
      }
    }
  };

  return (
    <div className="modal-availability">
      <ModalNotification>
        <div className="text-center my-5 my-md-0 ModalRenewal ">
          <nav>
            <button type="button" className="red-color btn-close" onClick={props.close}><span><i className="fas fa-times" /></span></button>
          </nav>
          <h1>{props.title}</h1>
          <p> {props.message}</p>
          <form name="formAvailability" action="" method="POST">
            <div className="mb-3">
              <input type="text" name="name" placeholder="Nombre" className="form-control " required />
            </div>
            <div className="mb-3">
              <input type="email" name="email" placeholder="Correo electrónico" className="form-control " required />
            </div>
            <button className="red-claro-btn FirstBtn" type="submit" onClick={handleSubmit}><span>{props.btnMessage}</span></button>
            {error ? <Notification title={error} /> : null}
          </form>
        </div>
      </ModalNotification>
    </div>
  );
};

export function InventoryModal({ item }) {
  const state = useInventoryText();
  const showModalState = useHookstate(inventoryModal);
  const [showModalSuccess, setShowModalSuccess] = useState(false);

  const handleSumbitNotifyMeAvailability = () => {
    showModalState.set(false);
    setShowModalSuccess(true);
  };

  return createPortal(
    <>
      {showModalState.value && (
        <ModalFormAvailability
          title={state.product_modal_stock_category_title.value}
          message={state.product_modal_stock_category_description.value}
          btnMessage={state.product_modal_stock_category_btnMesssage.value}
          close={() => showModalState.set(false)}
          notifyAvailability={handleSumbitNotifyMeAvailability}
          itemType={item.type}
          item={item}
        />
      )}
      {showModalSuccess && (
        <ModalAvailability
          title={state.prooduct_modal_stock_success_category_title.value}
          message={state.prooduct_modal_stock_success_category_description.value}
          btnMessage={state.prooduct_modal_stock_success_category_btnMessage.value}
          close={() => setShowModalSuccess(false)}
        />
      )}
    </>,
    document.body
  );
}
